import { appConstantUrl } from 'appConstant';
import {
  EU_SUPPLIER_PENDING_APPROVAL_LIST,
  EU_SUPPLIER_SUBMITTED_TO_EU_LIST,
  EU_SUPPLIER_ARCHIVED_LIST,
} from './types';
import { callAPI } from 'Action';
import { downloadPdfFile } from 'utils/common';

export const getEuStatusList = (tabChange) => async (dispatch: any) => {
  let url = appConstantUrl.fedsaDdsInfo;
  if (typeof tabChange != 'object') {
    url += `=${tabChange}`;
  } else {
    return;
  }
  const options = {
    url,
    method: 'GET',
    dispatch: null,
  };
  let list: any = await callAPI(options);

  if (tabChange === 'IKEA') {
    dispatch({
      type: EU_SUPPLIER_SUBMITTED_TO_EU_LIST,
      payload: list?.data,
    });
  } else if (tabChange === 'Supplier') {
    dispatch({
      type: EU_SUPPLIER_ARCHIVED_LIST,
      payload: list?.data,
    });
  }
};

export const downloadDDSPdf = (fedsaId: any) => async (dispatch) => {
  let url = `${appConstantUrl.pdfDownloadUrlEuSupplier}/${fedsaId}`;
  const options = {
    url,
    method: 'GET',
    dispatch: null,
  };

  try {
    let pdfData = await callAPI(options);
    if (pdfData && pdfData.data?.fileBytes) {
      downloadPdfFile(pdfData.data.fileBytes, pdfData);
      return { success: true };
    } else {
      throw new Error('No file bytes found');
    }
  } catch (error) {
    console.error('PDF download failed:', error);
    return { success: false, error: (error as any).message };
  }
};
